import { styled, Typography } from "@mui/material"

export const ErrorStyle = styled(Typography)(({ theme }) => ({
  color: theme.palette.mockup.error50,
  fontSize: "14px",
  position: "absolute",
  fontWeight: "500",
}))
